import _get from 'lodash/get';

export const shouldSynchronizeConsents = (
  isSynchronized,
  { features: { userApiFeature }, user: { deviceId, areUserPreferencesSet: areConsentsSet } },
) => !isSynchronized && userApiFeature && areConsentsSet && deviceId;

export const getDeviceId = ({ user: { deviceId } }) => deviceId;

export const getHomeId = ({ user: { homeId } }) => homeId;

export const getLocalDeviceId = ({ user: { localDeviceId } }) => localDeviceId;

export const getLocalHomeId = ({ user: { localHomeId } }) => localHomeId;

export const getPairingStatus = ({ pairing: { status } }) => status;

export const getUserState = ({ user, features: { userApiFeature } }) => ({ ...user, userApiFeature });

export const getPairedUser = ({ pairing }) => pairing;

export const getSelectedProfile = state => _get(state, 'pairing.profileUid');

export const getPairingUid = state => _get(getPairedUser(state), 'uid');

export const getCatalogAccess = ({ pairing: { catalogAccess } }) => catalogAccess;

export const getUid = ({ user: { uid } }) => uid;

export const getLastViewedClips = ({ user: { lastClips } }) => lastClips;

export const getProfileUsername = ({ user: { profileUsername } }) => profileUsername;

export const getProfilePhotoId = ({ user: { profileAvatarId } }) => profileAvatarId;

export const isKidsProfile = ({ user: { isKidsProfile } }) => isKidsProfile;

export const getHasGeoInfo = ({ user: { geo } }) => Boolean(geo);

export const getCookies = ({ user: { cookies } }) => cookies;

export const areGdprCookiesSet = ({ user: { areUserPreferencesSet } }) => areUserPreferencesSet;

export const getParentalLockStatus = ({ user: { parentalLockStatus } }) => parentalLockStatus;

export const getPreviousProfileUid = state => _get(state, 'user.previousProfileUid', null);

export const getAccountCompletionStatus = ({ user: { accountComplete } }) => accountComplete;
